<app-header *ngIf="!isAdmin"></app-header>

<div class="listing-container">
  <div class="listing-header">
    <div class="header-top" *ngIf="isAdmin">
      <button class="btn-back-admin" (click)="goBack()">
        <span class="icon">←</span>
        Back to Admin
      </button>
    </div>

    <div *ngIf="loading" class="loading-state">
      <div class="loader"></div>
      <p>Loading listing details...</p>
    </div>

    <div *ngIf="error && !loading" class="error-state">
      <div class="error-icon">⚠</div>
      <h3>Unable to Load Listing</h3>
      <p>{{ error }}</p>
      <button class="btn-primary" (click)="goBack()">Return to Listings</button>
    </div>

    <div *ngIf="messages.success" class="alert alert-success">
      <span class="alert-icon">✓</span>
      {{ messages.success }}
      <button class="alert-close" (click)="dismissMessage('success')">×</button>
    </div>

    <div *ngIf="messages.error" class="alert alert-error">
      <span class="alert-icon">⚠</span>
      {{ messages.error }}
      <button class="alert-close" (click)="dismissMessage('error')">×</button>
    </div>

    <div *ngIf="isEditMode" class="edit-mode-banner">
      <div class="edit-banner-content">
        <div class="edit-banner-text">
          <strong>Edit Mode Active</strong>
          <small
            >Make changes to the listing fields below and click Save when
            done</small
          >
        </div>
      </div>
    </div>

    <div *ngIf="!loading && !error && listing" class="listing-content">
      <div class="listing-header">
        <div class="header-main">
          <div class="listing-title-row">
            <h1 class="listing-title">{{ listing.title }}</h1>
            <div class="share-dropdown">
              <button
                class="share-btn"
                (click)="toggleShareMenu()"
                title="Share this listing"
              >
                <svg
                  class="btn-icon"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 5.12548 15.0077 5.24917 15.0227 5.37061L8.08259 9.19346C7.54305 8.46607 6.72123 8 5.8 8C4.14315 8 2.8 9.34315 2.8 11C2.8 12.6569 4.14315 14 5.8 14C6.72123 14 7.54305 13.5339 8.08259 12.8065L15.0227 16.6294C15.0077 16.7508 15 16.8745 15 17C15 18.6569 16.3431 20 18 20C19.6569 20 21 18.6569 21 17C21 15.3431 19.6569 14 18 14C17.0788 14 16.257 14.4661 15.7174 15.1935L8.77735 11.3706C8.79229 11.2492 8.8 11.1255 8.8 11C8.8 10.8745 8.79229 10.7508 8.77735 10.6294L15.7174 6.80654C16.257 7.53393 17.0788 8 18 8Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
              <div class="share-menu" *ngIf="showShareMenu">
                <button class="share-option" (click)="copyLink()">
                  Copy Link
                </button>
                <a
                  class="share-option"
                  [href]="getWhatsAppShareUrl()"
                  target="_blank"
                  rel="noopener"
                  >Share to WhatsApp</a
                >
                <a
                  class="share-option"
                  [href]="getFacebookShareUrl()"
                  target="_blank"
                  rel="noopener"
                  >Share to Facebook</a
                >
                <a
                  class="share-option"
                  [href]="getTwitterShareUrl()"
                  target="_blank"
                  rel="noopener"
                  >Share to X</a
                >
              </div>
            </div>
          </div>

          <div class="listing-meta-row">
            <div class="price-section">
              <span class="price-label">Price</span>
              <span class="price-value">{{ getMainPrice() }}</span>
            </div>
            <div class="status-section">
              <span class="status-label">Status</span>
              <span class="status-badge" [class]="'status-' + listing.status">{{
                getListingStatusText()
              }}</span>
            </div>
            <div *ngIf="isOwnerListing()" class="owner-section">
              <span class="status-label">Owner</span>
              <span class="owner-badge">Your Listing</span>
            </div>
          </div>
          <div class="listing-info-row">
            <span class="info-item">
              <span class="info-label">Listed:</span>
              <span class="info-value">{{
                formatDate(listing.created_at)
              }}</span>
            </span>
          </div>
        </div>
      </div>

      <div class="image-gallery-section">
        <div class="gallery-container">
          <div
            class="main-image-wrapper"
            (mouseenter)="onImageHover()"
            (mouseleave)="onImageLeave()"
          >
            <div
              class="image-frame"
              (touchstart)="onTouchStart($event)"
              (touchmove)="onTouchMove($event)"
              (touchend)="onTouchEnd($event)"
            >
              <img
                [src]="getCurrentImage()"
                [alt]="listing.title"
                class="main-image"
                (click)="onMobileImageClick($event)"
              />
              <div class="image-overlay-info">
                <span
                  class="image-counter desktop-only"
                  *ngIf="listingImages && listingImages.length > 0"
                >
                  {{ currentImageIndex + 1 }} / {{ listingImages.length }}
                </span>
                <span
                  class="image-counter no-images"
                  *ngIf="!listingImages || listingImages.length === 0"
                >
                  This listing does not have any image
                </span>
              </div>

              <div
                class="image-click-zones desktop-only"
                *ngIf="hasMultipleImages()"
              >
                <div
                  class="click-zone zone-left"
                  (click)="onImageZoneClick($event, 'prev')"
                  [attr.aria-label]="'Previous image'"
                >
                  <div class="zone-icon">
                    <svg viewBox="0 0 24 24" class="zone-svg">
                      <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                  </div>
                </div>
                <div
                  class="click-zone zone-middle"
                  (click)="openImageModal()"
                ></div>
                <div
                  class="click-zone zone-right"
                  (click)="onImageZoneClick($event, 'next')"
                  [attr.aria-label]="'Next image'"
                >
                  <div class="zone-icon">
                    <svg viewBox="0 0 24 24" class="zone-svg">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </div>
                </div>
              </div>

              <div
                class="carousel-controls desktop-only"
                *ngIf="hasMultipleImages() && showCarouselControls"
                [class.fading-out]="!showCarouselControls"
              >
                <div class="carousel-indicator">
                  <svg viewBox="0 0 24 24" class="carousel-icon">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </div>

                <div class="carousel-indicator">
                  <svg viewBox="0 0 24 24" class="carousel-icon">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </div>
              </div>

              <div class="image-dots mobile-only" *ngIf="hasMultipleImages()">
                <span
                  *ngFor="let image of listingImages; let i = index"
                  class="dot"
                  [class.active]="i === currentImageIndex"
                ></span>
              </div>
            </div>
          </div>

          <div *ngIf="hasMultipleImages()" class="thumbnails-strip">
            <div class="thumbnails-container">
              <div
                *ngFor="
                  let image of listingImages;
                  let i = index;
                  trackBy: trackByImageIndex
                "
                class="thumbnail-wrapper"
                [class.active]="i === currentImageIndex"
                (click)="selectImage(i)"
              >
                <img
                  [src]="image"
                  [alt]="listing.title"
                  class="thumbnail-image"
                />
                <div class="thumbnail-overlay"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content-layout">
        <div class="main-content-area">
          <div class="details-card professional-card">
            <div class="card-header">
              <h2 class="card-title">Listing Information</h2>
              <div class="card-divider"></div>
            </div>
            <div class="card-content">
              <div class="details-sections">
                <form
                  *ngIf="isEditMode"
                  [formGroup]="editForm"
                  class="edit-form-inline"
                >
                  <div
                    *ngFor="
                      let section of getFieldSections() | keyvalue;
                      trackBy: trackBySectionKey
                    "
                    class="detail-section"
                  >
                    <h3 class="section-title">{{ section.key }}</h3>
                    <div class="section-grid">
                      <div
                        *ngFor="
                          let field of section.value;
                          trackBy: trackByFieldName
                        "
                        class="field-row"
                      >
                        <ng-container
                          *ngIf="
                            shouldShowField(field) && !shouldHideField(field)
                          "
                        >
                          <div
                            class="field-container"
                            [class.description-field]="
                              isDescriptionField(field)
                            "
                            [class.edit-mode]="
                              isEditMode && isFieldEditable(field)
                            "
                            [class.vehicle-selector-container]="
                              shouldShowVehicleSelector(field)
                            "
                          >
                            <span class="field-label">{{ field.label }}</span>

                            <ng-container *ngIf="isFieldEditable(field)">
                              <ng-container
                                *ngIf="
                                  isAutomobile(
                                    getSubcategoryName(listing.table_name)
                                  )
                                "
                              >
                                <app-vehicle-selector
                                  *ngIf="shouldShowVehicleSelector(field)"
                                  [formControlName]="field.name"
                                  [required]="field.required || false"
                                  class="vehicle-selector-edit"
                                >
                                </app-vehicle-selector>
                              </ng-container>

                              <ng-container
                                *ngIf="
                                  isMotorcycle(
                                    getSubcategoryName(listing.table_name)
                                  )
                                "
                              >
                                <app-motorcycle-brand-selector
                                  *ngIf="shouldShowMotorcycleSelector(field)"
                                  [formControlName]="field.name"
                                  [required]="field.required || false"
                                  class="vehicle-selector-edit"
                                >
                                </app-motorcycle-brand-selector>
                              </ng-container>

                              <app-location-autocomplete
                                *ngIf="
                                  isLocationField(field.name) &&
                                  !isVehicleSelectorField(field.name)
                                "
                                [formControlName]="field.name"
                                (locationSelectedWithCoords)="
                                  onLocationSelected($event)
                                "
                                [placeholder]="field.label"
                                class="location-autocomplete-edit"
                              >
                              </app-location-autocomplete>

                              <input
                                *ngIf="
                                  (field.type === 'text' ||
                                    field.type === 'number' ||
                                    field.type === 'email' ||
                                    field.type === 'tel' ||
                                    field.type === 'location') &&
                                  !isVehicleSelectorField(field.name) &&
                                  !isLocationField(field.name)
                                "
                                [type]="
                                  field.type === 'location'
                                    ? 'text'
                                    : field.type
                                "
                                class="field-input"
                                [class.is-invalid]="isFieldInvalid(field.name)"
                                [formControlName]="field.name"
                                [placeholder]="field.label"
                                (wheel)="preventNumberScroll($event)"
                              />

                              <textarea
                                *ngIf="
                                  (field.type === 'textarea' ||
                                    isDescriptionField(field)) &&
                                  !isVehicleSelectorField(field.name) &&
                                  !isLocationField(field.name)
                                "
                                class="field-textarea"
                                [class.is-invalid]="isFieldInvalid(field.name)"
                                [formControlName]="field.name"
                                [placeholder]="field.label"
                                rows="6"
                              ></textarea>

                              <select
                                *ngIf="
                                  field.type === 'select' &&
                                  field.options &&
                                  !isVehicleSelectorField(field.name)
                                "
                                class="field-select"
                                [class.is-invalid]="isFieldInvalid(field.name)"
                                [formControlName]="field.name"
                              >
                                <option value="">
                                  Select {{ field.label }}
                                </option>
                                <option
                                  *ngFor="
                                    let option of field.options;
                                    trackBy: trackByOptionValue
                                  "
                                  [value]="option.value"
                                >
                                  {{ option.label }}
                                </option>
                              </select>

                              <input
                                *ngIf="
                                  field.type === 'date' &&
                                  !isVehicleSelectorField(field.name)
                                "
                                type="date"
                                class="field-input"
                                [class.is-invalid]="isFieldInvalid(field.name)"
                                [formControlName]="field.name"
                              />

                              <div
                                *ngIf="
                                  (field.type ===
                                    'first_registration_dropdown' ||
                                    field.type ===
                                      'registered_until_dropdown') &&
                                  !isVehicleSelectorField(field.name)
                                "
                                class="dropdown-group"
                              >
                                <select
                                  [id]="field.name + '_month'"
                                  class="field-select dropdown-half"
                                  [value]="
                                    (dateFieldsData[field.name] &&
                                      dateFieldsData[field.name].month) ||
                                    ''
                                  "
                                  (change)="
                                    onDateMonthChange($event, field.name)
                                  "
                                  [class.is-invalid]="
                                    isFieldInvalid(field.name)
                                  "
                                >
                                  <option value="">Month</option>
                                  <option
                                    *ngFor="let month of monthOptions"
                                    [value]="month.value"
                                    [disabled]="
                                      isMonthDisabled(month.value, field.name)
                                    "
                                  >
                                    {{ month.label }}
                                  </option>
                                </select>

                                <select
                                  [id]="field.name + '_year'"
                                  class="field-select dropdown-half"
                                  [value]="
                                    (dateFieldsData[field.name] &&
                                      dateFieldsData[field.name].year) ||
                                    ''
                                  "
                                  (change)="
                                    onDateYearChange($event, field.name)
                                  "
                                  [class.is-invalid]="
                                    isFieldInvalid(field.name)
                                  "
                                >
                                  <option value="">Year</option>
                                  <option
                                    *ngFor="
                                      let year of getYearOptionsForField(
                                        field.name
                                      )
                                    "
                                    [value]="year"
                                  >
                                    {{ year }}
                                  </option>
                                </select>
                              </div>

                              <label
                                *ngIf="
                                  field.type === 'checkbox' &&
                                  !isVehicleSelectorField(field.name)
                                "
                                class="field-checkbox"
                              >
                                <input
                                  type="checkbox"
                                  [formControlName]="field.name"
                                />
                                <span>Yes</span>
                              </label>

                              <div
                                *ngIf="isFieldInvalid(field.name)"
                                class="field-error-message"
                              >
                                {{ getFieldError(field) }}
                              </div>
                            </ng-container>

                            <span
                              *ngIf="!isEditMode || !isFieldEditable(field)"
                              class="field-value"
                              [class.not-specified]="!hasFieldValue(field.name)"
                              >{{
                                formatFieldValue(
                                  field,
                                  getFieldValue(field.name)
                                )
                              }}</span
                            >
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </form>

                <div *ngIf="!isEditMode">
                  <div
                    *ngFor="
                      let section of getFieldSections() | keyvalue;
                      trackBy: trackBySectionKey
                    "
                    class="detail-section"
                  >
                    <h3 class="section-title">{{ section.key }}</h3>
                    <div class="section-grid">
                      <div
                        *ngFor="
                          let field of section.value;
                          trackBy: trackByFieldName
                        "
                        class="field-row"
                      >
                        <ng-container
                          *ngIf="
                            shouldShowField(field) && !shouldHideField(field)
                          "
                        >
                          <div
                            class="field-container"
                            [class.description-field]="
                              isDescriptionField(field)
                            "
                          >
                            <span class="field-label">{{ field.label }}</span>
                            <span
                              class="field-value"
                              [class.not-specified]="!hasFieldValue(field.name)"
                              >{{
                                formatFieldValue(
                                  field,
                                  getFieldValue(field.name)
                                )
                              }}</span
                            >
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="isVehicleCategory() && hasFeatures"
            class="details-card features-card"
          >
            <div class="card-header">
              <h2 class="card-title">Vehicle Features & Specifications</h2>
              <div class="card-divider"></div>
            </div>
            <div class="card-content">
              <div class="features-grid">
                <div
                  *ngFor="
                    let category of getFeatureCategories();
                    trackBy: trackByCategory
                  "
                  class="feature-category-section"
                >
                  <h3 class="feature-category-title">
                    {{ formatCategoryName(category) }}
                  </h3>
                  <div class="features-list">
                    <div
                      *ngFor="
                        let feature of getFeaturesInCategory(category);
                        trackBy: trackByFeatureId
                      "
                      class="feature-item"
                    >
                      <span class="feature-name">{{
                        feature.feature_name
                      }}</span>
                      <span
                        *ngIf="feature.description"
                        class="feature-description"
                        >{{ feature.description }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="hasLocationForMap" class="details-card location-card">
            <div class="card-header">
              <h2 class="card-title">Location & Map</h2>
              <div class="card-divider"></div>
            </div>
            <div class="card-content">
              <div class="location-details">
                <div class="location-info">
                  <h3 class="location-name">{{ getLocationDisplayName() }}</h3>
                  <p class="location-description">
                    View the general area of this listing on the interactive map
                    below.
                  </p>
                </div>
                <div class="map-wrapper">
                  <app-google-map
                    [cityName]="locationForMap"
                    [locationName]="getLocationDisplayName()"
                    [height]="'280px'"
                    [width]="'100%'"
                    [zoom]="10"
                  >
                  </app-google-map>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="sidebar-area">
          <div class="sidebar-card seller-card">
            <div class="card-header">
              <h3 class="card-title">Seller Information</h3>
              <div class="card-divider"></div>
            </div>
            <div class="card-content">
              <div class="seller-profile">
                <div class="seller-avatar">
                  <span class="avatar-initial">{{
                    getOwnerName().charAt(0).toUpperCase()
                  }}</span>
                </div>
                <div class="seller-details">
                  <h4 class="seller-name">{{ getOwnerName() }}</h4>
                  <span class="seller-label">Verified Seller</span>
                </div>
              </div>

              <div
                *ngIf="(!isOwnerListing() && isUserLoggedIn()) || isAdmin"
                class="contact-section"
              >
                <div class="contact-methods">
                  <div *ngIf="listing.email" class="contact-item">
                    <span class="contact-icon">✉️</span>
                    <span class="contact-info">{{ listing.email }}</span>
                  </div>
                  <div *ngIf="listing.phone_number" class="contact-item">
                    <span class="contact-icon">📞</span>
                    <span class="contact-info">{{ listing.phone_number }}</span>
                  </div>
                </div>
              </div>

              <div
                *ngIf="!isOwnerListing() && !isUserLoggedIn() && !isAdmin"
                class="login-prompt"
              >
                <div class="prompt-content">
                  <p>Sign in to view complete contact details</p>
                  <button
                    class="btn-secondary btn-small"
                    (click)="showLoginPrompt()"
                  >
                    Sign In
                  </button>
                </div>
              </div>

              <div class="action-section">
                <div class="action-row">
                  <button
                    *ngIf="canMessageSeller()"
                    class="btn-primary btn-full"
                    (click)="messageSeller()"
                  >
                    Contact Seller
                  </button>

                  <div
                    *ngIf="!isOwnerListing() && canUseWishlist() && !isAdmin"
                    class="wishlist-heart-container"
                  >
                    <app-wishlist-heart
                      [listingId]="listing.id.toString()"
                      [tableName]="listing.table_name"
                    >
                    </app-wishlist-heart>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="sidebar-card summary-card">
            <div class="card-header">
              <h3 class="card-title">Listing Summary</h3>
              <div class="card-divider"></div>
            </div>
            <div class="card-content">
              <div class="summary-grid">
                <div class="summary-row">
                  <span class="summary-label">Asking Price</span>
                  <span class="summary-value price-value">{{
                    getMainPrice()
                  }}</span>
                </div>

                <div class="summary-row">
                  <span class="summary-label">Current Status</span>
                  <span class="summary-value">
                    <span
                      class="status-indicator"
                      [class]="'status-' + listing.status"
                    ></span>
                    {{ getListingStatusText() }}
                  </span>
                </div>

                <div class="summary-row">
                  <span class="summary-label">Date Listed</span>
                  <span class="summary-value">{{
                    formatDate(listing.created_at)
                  }}</span>
                </div>

                <div *ngIf="listing.status === 'pending'" class="summary-row">
                  <span class="summary-label">Admin Review</span>
                  <span class="summary-value pending-info">
                    Awaiting approval
                  </span>
                </div>

                <div *ngIf="shouldShowExpiryInfo()" class="summary-row">
                  <span class="summary-label">{{
                    isListingExpired() ? "Expired On" : "Expires"
                  }}</span>
                  <span
                    class="summary-value"
                    [class]="getExpirationStatusClass()"
                  >
                    {{ getExpirationDisplayText() }}
                  </span>
                </div>

                <div
                  *ngIf="shouldShowPendingExpiryMessage()"
                  class="summary-row"
                >
                  <span class="summary-label">Expiry Date</span>
                  <span class="summary-value pending-info">
                    Will be available once admin approves
                  </span>
                </div>

                <div *ngIf="shouldShowDeclinedMessage()" class="summary-row">
                  <span class="summary-label">Status</span>
                  <span class="summary-value declined-info">
                    Your listing was declined. <br />Please edit and resubmit.
                  </span>
                </div>

                <div *ngIf="shouldShowExpiryInfo()" class="summary-row">
                  <span class="summary-label">Expiry Date</span>
                  <span class="summary-value">{{
                    formatExpirationDate(listing.expires_at)
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="shouldShowExpiryInfo() && !isListingExpired()"
            class="sidebar-card timer-card"
          >
            <div class="card-header">
              <h3 class="card-title">Time Remaining</h3>
              <div class="card-divider"></div>
            </div>
            <div class="card-content">
              <div class="timer-wrapper">
                <app-countdown-timer
                  [expiresAt]="listing.expires_at || null"
                  [showSeconds]="shouldShowSeconds()"
                  [updateInterval]="1000"
                  [listingStatus]="listing.status"
                >
                </app-countdown-timer>
              </div>
            </div>
          </div>

          <div
            *ngIf="listing.status === 'pending' && isOwnerListing() && !isAdmin"
            class="sidebar-card pending-card"
          >
            <div class="card-header">
              <h3 class="card-title">Pending Approval</h3>
              <div class="card-divider"></div>
            </div>
            <div class="card-content">
              <div class="pending-info-content">
                <div class="pending-notice">
                  <span class="pending-icon">⏳</span>
                  <div class="pending-text">
                    <strong>Your listing is under review</strong>
                    <small
                      >Expiry date will be set once admin approves your
                      listing</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="isOwnerListing() && !isAdmin"
            class="sidebar-card owner-card"
          >
            <div class="card-header">
              <h3 class="card-title">Manage Your Listing</h3>
              <div class="card-divider"></div>
            </div>
            <div class="card-content">
              <div class="owner-actions">
                <button
                  class="btn-secondary btn-full"
                  (click)="editListing()"
                  [disabled]="
                    listing.status === 'deleted' || isListingExpired()
                  "
                >
                  <span class="btn-icon">✏</span>
                  Edit Listing
                </button>
                <button
                  class="btn-danger btn-full"
                  (click)="onDeleteListing()"
                  [disabled]="
                    listing.status === 'deleted' || isListingExpired()
                  "
                >
                  <span class="btn-icon">🗑</span>
                  Delete Listing
                </button>

                <div
                  *ngIf="listing.status === 'deleted'"
                  class="status-notice deleted"
                >
                  <span class="notice-icon">⚠</span>
                  This listing has been deleted and cannot be modified
                </div>
                <div
                  *ngIf="isListingExpired() && listing.status !== 'deleted'"
                  class="status-notice expired"
                >
                  <span class="notice-icon">⏰</span>
                  This listing has expired and cannot be modified
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="isAdmin" class="sidebar-card admin-card">
            <div class="card-header">
              <h3 class="card-title">Administrative Controls</h3>
              <div class="card-divider"></div>
            </div>
            <div class="card-content">
              <div class="admin-info">
                <div class="admin-badge">
                  <span class="badge-icon">⚡</span>
                  <span>Administrator Access</span>
                </div>
                <div class="admin-status">
                  <span class="status-label">Current Status:</span>
                  <span
                    class="status-value"
                    [class]="'status-' + listing.status"
                    >{{ listing.status | titlecase }}</span
                  >
                </div>
              </div>

              <div class="admin-actions">
                <button
                  *ngIf="canEdit()"
                  class="btn-primary btn-full"
                  (click)="enableEditMode()"
                  [disabled]="adminProcessing || isEditMode"
                >
                  Edit Listing
                </button>

                <div *ngIf="isEditMode" class="edit-mode-actions">
                  <button
                    class="btn-success btn-full"
                    (click)="saveEditedListing()"
                    [disabled]="editLoading || !hasUnsavedChanges()"
                  >
                    <span class="btn-icon">💾</span>
                    {{ editLoading ? "Saving..." : "Save Changes" }}
                  </button>
                  <button
                    class="btn-secondary btn-full"
                    (click)="cancelEditMode()"
                    [disabled]="editLoading"
                  >
                    <span class="btn-icon">✕</span>
                    Cancel
                  </button>
                  <div *ngIf="hasUnsavedChanges()" class="unsaved-indicator">
                    <span class="indicator-icon">⚠️</span>
                    <span>Unsaved changes</span>
                  </div>
                </div>

                <button
                  *ngIf="canApprove() && !isEditMode"
                  class="btn-success btn-full"
                  (click)="showApproveModal()"
                  [disabled]="adminProcessing"
                >
                  <span class="btn-icon">✓</span>
                  Approve Listing
                </button>
                <button
                  *ngIf="canDecline() && !isEditMode"
                  class="btn-danger btn-full"
                  (click)="showDeclineModal()"
                  [disabled]="adminProcessing"
                >
                  <span class="btn-icon">✕</span>
                  Decline Listing
                </button>

                <div
                  *ngIf="!canApprove() && !canDecline() && !canEdit()"
                  class="no-actions"
                >
                  <span class="no-actions-icon">✨</span>
                  <span>No actions available for current status</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!isOwnerListing() && !isAdmin" class="similar-section">
        <div class="section-header">
          <h2 class="section-title">Similar Listings</h2>
        </div>

        <div *ngIf="isLoadingSuggested" class="loading-grid">
          <div class="loading-card" *ngFor="let i of [1, 2, 3, 4]">
            <div class="loading-image"></div>
            <div class="loading-content">
              <div class="loading-line title"></div>
              <div class="loading-line price"></div>
              <div class="loading-line location"></div>
            </div>
          </div>
        </div>

        <div
          *ngIf="!isLoadingSuggested && suggestedListings.length > 0"
          class="suggestions-grid"
        >
          <div
            *ngFor="
              let suggestion of suggestedListings;
              trackBy: trackByListingId
            "
            class="suggestion-card"
            (click)="onSuggestedListingClick(suggestion)"
          >
            <div class="suggestion-image-wrapper">
              <img
                [src]="suggestion.image"
                [alt]="suggestion.title"
                class="suggestion-image"
              />
              <div class="suggestion-overlay">
                <span class="view-details">View Details</span>
              </div>
            </div>
            <div class="suggestion-content">
              <h3 class="suggestion-title">{{ suggestion.title }}</h3>
              <div class="suggestion-meta">
                <span class="suggestion-price">{{
                  formatSuggestedListingPrice(suggestion)
                }}</span>
                <span class="suggestion-location">{{
                  suggestion.location
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="!isLoadingSuggested && suggestedListings.length === 0"
          class="no-suggestions"
        >
          <div class="no-suggestions-content">
            <span class="no-suggestions-icon">🔍</span>
            <h3>No Similar Listings Found</h3>
            <p>
              We couldn't find any similar listings at the moment. Check back
              later for new arrivals.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="imageModal.show"
    class="image-modal-overlay"
    (click)="closeImageModal()"
  >
    <div class="image-modal-container" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div class="modal-title-section">
          <h2 class="modal-title">{{ listing?.title }}</h2>
          <div class="modal-subtitle">
            <span class="image-position"
              >Image {{ imageModal.currentIndex + 1 }} of
              {{ listingImages.length }}</span
            >
            <span class="modal-separator">•</span>
            <span class="modal-category">{{
              getCategoryName(listing?.table_name || "")
            }}</span>
          </div>
        </div>
        <button
          class="modal-close-btn"
          (click)="closeImageModal()"
          title="Close (ESC)"
        >
          <span class="close-icon">✕</span>
        </button>
      </div>

      <div class="modal-image-area">
        <div
          class="image-container"
          (touchstart)="onModalTouchStart($event)"
          (touchmove)="onModalTouchMove($event)"
          (touchend)="onModalTouchEnd($event)"
        >
          <img
            [src]="getCurrentModalImage()"
            [alt]="listing?.title + ' - Image ' + (imageModal.currentIndex + 1)"
            class="modal-image"
          />

          <div
            *ngIf="hasMultipleImages() && !isTouchDevice()"
            class="modal-controls"
          >
            <button
              class="modal-nav-btn prev-btn"
              (click)="previousModalImage()"
              title="Previous image (←)"
            >
              <span class="nav-arrow">‹</span>
            </button>
            <button
              class="modal-nav-btn next-btn"
              (click)="nextModalImage()"
              title="Next image (→)"
            >
              <span class="nav-arrow">›</span>
            </button>
          </div>

          <div class="image-info-overlay">
            <div class="image-counter-modal">
              {{ imageModal.currentIndex + 1 }} / {{ listingImages.length }}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="hasMultipleImages()" class="modal-thumbnails-section">
        <div class="thumbnails-track">
          <div
            *ngFor="
              let image of listingImages;
              let i = index;
              trackBy: trackByImageIndex
            "
            class="modal-thumbnail-wrapper"
            [class.active]="i === imageModal.currentIndex"
            (click)="selectModalImage(i)"
          >
            <img [src]="image" [alt]="listing?.title" class="modal-thumbnail" />
            <div class="thumbnail-overlay-modal"></div>
          </div>
        </div>
      </div>

      <div class="modal-footer" *ngIf="!isTouchDevice()">
        <div class="modal-hints">
          <span class="hint-item">
            <span class="hint-icon">⌨</span>
            Use arrow keys to navigate
          </span>
          <span class="hint-separator">•</span>
          <span class="hint-item">
            <span class="hint-icon">⎋</span>
            Press ESC to close
          </span>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="deleteConfirmation.show"
    class="modal-overlay"
    (click)="cancelDelete()"
  >
    <div class="confirm-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">Confirm Deletion</h3>
        <button class="modal-close" (click)="cancelDelete()">×</button>
      </div>
      <div class="modal-content">
        <div class="confirmation-icon">⚠</div>
        <p class="confirmation-text">
          Are you sure you want to permanently delete this listing?
        </p>
        <div class="listing-preview">
          <strong>{{ listing?.title }}</strong>
          <small
            >{{ getCategoryName(listing?.table_name || "") }} -
            {{ getSubcategoryName(listing?.table_name || "") }}</small
          >
        </div>
        <p class="warning-text">
          This action cannot be undone and will permanently remove your listing.
        </p>
      </div>
      <div class="modal-actions">
        <button
          class="btn-secondary"
          (click)="cancelDelete()"
          [disabled]="deleteConfirmation.deleting"
        >
          Cancel
        </button>
        <button
          class="btn-danger"
          (click)="confirmDelete()"
          [disabled]="deleteConfirmation.deleting"
        >
          {{ deleteConfirmation.deleting ? "Deleting..." : "Delete Listing" }}
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="adminActionModal.show"
    class="modal-overlay"
    (click)="closeAdminActionModal()"
  >
    <div class="admin-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">
          {{ adminActionModal.action === "approve" ? "Approve" : "Decline" }}
          Listing
        </h3>
        <button class="modal-close" (click)="closeAdminActionModal()">×</button>
      </div>
      <div class="modal-content">
        <div class="listing-preview">
          <strong>{{ listing?.title }}</strong>
          <small
            >{{ getCategoryName(listing?.table_name || "") }} -
            {{ getSubcategoryName(listing?.table_name || "") }}</small
          >
        </div>

        <div class="form-group" *ngIf="adminActionModal.action === 'approve'">
          <label for="admin-note">Admin Note (Optional):</label>
          <textarea
            id="admin-note"
            [(ngModel)]="adminActionModal.note"
            placeholder="Add a helpful note for the seller..."
            rows="3"
          >
          </textarea>
        </div>

        <div class="form-group" *ngIf="adminActionModal.action === 'decline'">
          <label for="decline-reason"
            >Reason for Decline (Required - Min 20 characters):</label
          >
          <textarea
            id="decline-reason"
            [(ngModel)]="adminActionModal.reason"
            placeholder="Please provide a detailed reason for declining this listing (minimum 20 characters)..."
            rows="4"
            required
            [class.invalid]="
              adminActionModal.reason.length > 0 && !isDeclineReasonValid()
            "
          >
          </textarea>
          <div
            *ngIf="adminActionModal.reason.length > 0"
            class="character-count"
            [class.valid]="isDeclineReasonValid()"
            [class.invalid]="!isDeclineReasonValid()"
          >
            {{ adminActionModal.reason.trim().length }}/20 characters
          </div>
          <div
            *ngIf="
              adminActionModal.reason.length > 0 && !isDeclineReasonValid()
            "
            class="warning-text"
          >
            ⚠️ Please provide at least 20 characters explaining the reason for
            decline.
          </div>
        </div>
      </div>
      <div class="modal-actions">
        <button
          class="btn-secondary"
          (click)="closeAdminActionModal()"
          [disabled]="adminActionModal.processing"
        >
          Cancel
        </button>
        <button
          class="btn-primary"
          [class.btn-danger]="adminActionModal.action === 'decline'"
          [class.btn-success]="adminActionModal.action === 'approve'"
          (click)="confirmAdminAction()"
          [disabled]="
            adminActionModal.processing ||
            (adminActionModal.action === 'decline' && !isDeclineReasonValid())
          "
        >
          {{
            adminActionModal.processing
              ? "Processing..."
              : adminActionModal.action === "approve"
              ? "Approve"
              : "Decline"
          }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-message-compose-modal
  [show]="messageModal.show"
  [data]="messageModal.data"
  (send)="onSendFirstMessage($event)"
  (cancel)="closeMessageModal()"
>
</app-message-compose-modal>

<app-footer *ngIf="!isAdmin"></app-footer>
